import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ChainableNumberInput } from './chainable-number-input';
import { clamp } from '../helpers';
export const MinutesInput = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    value,
    onChange,
    onBlur,
    ...rest
  } = props;
  const handleBlur = event => {
    onBlur == null || onBlur(event);
    if (value) {
      onChange == null || onChange(clamp(parseInt(value, 10), 0, 59).toString().padStart(2, '0'));
    }
  };
  return /*#__PURE__*/React.createElement(ChainableNumberInput, _extends({
    ref: ref,
    min: 0,
    max: 59,
    value: value,
    onBlur: handleBlur,
    onChange: onChange,
    "data-hook": "minutes"
  }, rest));
});
MinutesInput.displayName = 'MinutesInput';
//# sourceMappingURL=minutes-input.js.map